import UsersTable from "./usersTable";

export default UsersTable;
